(function () {
  var button = document.getElementById('intovent-back-to-top');
  if (!button) return;

  var SHOW_AFTER = 400;

  function updateVisibility() {
    button.classList.toggle('is-visible', window.scrollY > SHOW_AFTER);
  }

  window.addEventListener('scroll', updateVisibility, { passive: true });
  updateVisibility();

  button.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
